import Usuarios from './pages/custom/usuarios/Usuarios';
import Indicadores from './pages/custom/indicadores/Indicadores';
import Empresas from './pages/custom/empresas/Empresas';
import EmpresasUsuarios from './pages/custom/empresas_usuarios/EmpresasUsuarios';

export default 
[
    {
        path: '/usuarios',
        name: 'Usuarios',
        component: Usuarios
    },
    {
        path: '/indicadores',
        name: 'Indicadores',
        component: Indicadores
    },
    {
        path: '/empresas',
        name: 'Empresas',
        component: Empresas
    },
    {
        path: '/empresas_usuarios',
        name: 'EmpresasUsuarios',
        component: EmpresasUsuarios
    }
]

